<template>
  <div class="bb-index-cell">
    <div v-if="notKPI" class="bb-index-cell__not-kpi">{{index + 1}}</div>
    <div v-else class="bb-index-cell__item"
         ref="iconPopup"
         @mouseenter="setPositionPopup($event, row._id)"
         @mouseleave="showPopup = false"
    >
      {{index + 1}}
    </div>
    <transition name="fade" mode="out-in">
      <div class="bb-index-cell-popup"
           :style="openKpiSettings"
           v-if="showPopup === row._id"
      >
        <SettingsKPI :edit-position="valueKPI"
                     :title="valueKPI.name"
                     :preview="true"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash'
import SettingsKPI from '@/components/Settings/PositionsList/Positions/SettingsKPI/SettingsKPI'
export default {
  name: 'IndexCell',
  props: ['row', 'column', 'index'],
  components: {
    SettingsKPI
  },
  data () {
    return {
      showPopup: false,
      popupPosition: {},
      openKpiSettings: {
        left: 0,
        top: 0
      }
    }
  },
  computed: {
    valueKPI () {
      const kpiSettings = _.get(this.row, this.column.prop, '')
      return kpiSettings
    },
    notKPI () {
      return _.get(this.column, 'notKPI', false)
    }
  },
  methods: {
    setPositionPopup (e, rowId) {
      this.showPopup = rowId
      const popups = _.get(this.$refs, 'iconPopup', '')
      const popupWidth = _.get(popups[0], 'offsetWidth', 0)
      const diffLeft = popupWidth / 2
      const box = e.target.getBoundingClientRect()
      this.openKpiSettings = {
        left: (box.left - diffLeft + 5) + 'px',
        top: box.top + 30 + 'px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-index-cell {
  position: relative;
  @include global-font;

  &-popup {
    position: fixed;
    background-color: $color-white;
    padding: 21px;
    border-radius: 8px;
    box-shadow: 0 0 15px rgba($color-black, 0.1);
    z-index: 99;
  }

  &__not-kpi {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 17px;
    height: 17px;
    background: rgba($color-accent, 0.15);
    border-radius: 50%;
    color: $color-accent;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
  }

  &__item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    color: $color-denim;
    border: 1px solid $color-denim;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/IndexCell/IndexCell.vue